<template>
  <div>
    <transition name="scroll-y-transition" mode="out-in">
      <form :key="searchDTO.advanced">
        <v-row no-gutters class="mt-4">
          <v-col v-if="!isSingleCourtMode" cols="12">
            <c-autocomplete
              :items="courts"
              v-model="searchDTO.courtID"
              item-text="displayName"
              item-value="resourceID"
              :label="$t('page.searchCriteria.case.field.court')"
              outlined
              @change="changeCourt"
              key="courtID"
              hide-details="auto"
              aria-describedby="adf6e5a4-b099-4b21-8a92-572059ce793a"/>
            <field-description id="adf6e5a4-b099-4b21-8a92-572059ce793a"
                               message-key="page.searchCriteria.case.field.court.description"/>
          </v-col>
          <v-col v-if="!isSingleCaseLocationMode" cols="12">
            <c-autocomplete
              v-model="searchDTO.case.locationID"
              :items="caseLocations"
              item-text="locationName"
              item-value="locationID"
              :label="$t('page.searchCriteria.case.field.location')"
              :no-data-text="$t('global.courtFirst')"
              outlined
              hide-details="auto"
              aria-describedby="ab3ed0b5-d93e-4428-8dcc-522f77c9e6c8"/>
            <field-description id="ab3ed0b5-d93e-4428-8dcc-522f77c9e6c8"
                               message-key="page.searchCriteria.case.field.location.description"/>
          </v-col>
          <v-col cols="12">
            <c-text-field
              v-model="searchDTO.case.caseNumber"
              :label="$t('page.searchCriteria.case.field.caseNumber')"
              maxlength="250"
              outlined
              hide-details="auto"
              aria-describedby="ac5ce72e-e17f-447a-9697-f9a7bd172b2a"/>
            <field-description id="ac5ce72e-e17f-447a-9697-f9a7bd172b2a"
                               message-key="page.searchCriteria.case.field.caseNumber.description"/>
          </v-col>
          <v-col cols="12">
            <c-text-field
              v-model="searchDTO.case.alternateCaseNumber"
              :label="$t('page.searchCriteria.case.field.alternateCaseNumber')"
              maxlength="250"
              outlined
              hide-details="auto"
              aria-describedby="4830e553-7414-45cd-97f9-44e848620f5a"/>
            <field-description id="4830e553-7414-45cd-97f9-44e848620f5a"
                               message-key="page.searchCriteria.case.field.alternateCaseNumber.description"/>
          </v-col>
          <v-col cols="12">
            <c-text-field
              v-model="searchDTO.case.caseTitle"
              :label="$t('page.searchCriteria.case.field.caseTitle')"
              maxlength="250"
              outlined
              hide-details="auto"
              aria-describedby="a575f370-e512-47a7-a3e0-e24d1adfc836"/>
            <field-description id="a575f370-e512-47a7-a3e0-e24d1adfc836"
                               message-key="page.searchCriteria.case.field.caseTitle.description"/>
          </v-col>
          <v-col v-if="searchDTO.advanced" cols="12">
            <c-autocomplete
              v-model="searchDTO.case.caseTitleQueryTypeID"
              :label="$t('page.searchCriteria.case.field.caseTitleSearchType')"
              :items="queryTypes"
              outlined
              class="ml-8"
              :clearable="false"
              hide-details="auto"
              aria-describedby="a6b94c73-6561-424b-835f-88e8465eff15"/>
            <field-description id="a6b94c73-6561-424b-835f-88e8465eff15" class="ml-8"
                               message-key="global.queryType.description"/>
          </v-col>
          <v-col cols="12">
            <c-autocomplete
              v-model="searchDTO.case.caseCategoryID"
              :items="categories"
              item-text="caseCategoryName"
              item-value="caseCategoryID"
              :label="$t('page.searchCriteria.case.field.caseCategory')"
              :no-data-text="$t('global.courtFirst')"
              outlined
              @change="changeCategory"
              hide-details="auto"
              aria-describedby="a8865f7f-cc2a-4adc-b6bf-b3b62a423397"/>
            <field-description id="a8865f7f-cc2a-4adc-b6bf-b3b62a423397"
                               message-key="page.searchCriteria.case.field.caseCategory.description"/>
          </v-col>
          <v-col v-if="searchDTO.advanced" cols="12">
            <c-autocomplete
              v-model="searchDTO.case.caseTypeID"
              :items="caseTypes"
              item-text="caseTypeName"
              item-value="caseTypeID"
              :label="$t('page.searchCriteria.case.field.caseType')"
              :no-data-text="$t('global.caseCategoryFirst')"
              outlined
              @change="changeType"
              hide-details="auto"
              aria-describedby="f967a6f5-c041-4f23-9085-1c53a047f03b"/>
            <field-description id="f967a6f5-c041-4f23-9085-1c53a047f03b"
                               message-key="page.searchCriteria.case.field.caseType.description"/>
          </v-col>
          <v-col v-if="searchDTO.advanced" cols="12">
            <c-autocomplete
              v-model="searchDTO.case.caseSubTypeID"
              :items="caseSubTypes"
              item-text="caseSubTypeName"
              item-value="caseSubTypeID"
              :label="$t('page.searchCriteria.case.field.caseSubType')"
              :no-data-text="$t('global.caseTypeFirst')"
              outlined
              hide-details="auto"
              aria-describedby="a1a16df1-454c-4527-8f44-446902570413"/>
            <field-description id="a1a16df1-454c-4527-8f44-446902570413"
                               message-key="page.searchCriteria.case.field.caseSubType.description"/>
          </v-col>
          <v-col cols="12">
            <c-autocomplete
              v-model="searchDTO.case.caseStatusID"
              :items="caseStatusTypes"
              item-text="caseStatusTypeName"
              item-value="caseStatusTypeID"
              :label="$t('page.searchCriteria.case.field.caseStatusType')"
              outlined
              hide-details="auto"
              aria-describedby="2ca50655-77e0-4d19-9456-1a264e8ff957"/>
            <field-description id="2ca50655-77e0-4d19-9456-1a264e8ff957"
                               message-key="page.searchCriteria.case.field.caseStatusType.description"/>
          </v-col>
          <v-col cols="12">
            <date-range-picker
              :label="$t('page.searchCriteria.case.field.caseFiledDate')"
              :labelStart="$t('page.searchCriteria.case.field.caseFiledDateFrom')"
              :labelEnd="$t('page.searchCriteria.case.field.caseFiledDateTo')"
              keyPrefix="caseFiledDate"
              :inputAttributes="{ outlined: true }"
              :choice.sync="searchDTO.case.filedDateChoice"
              :startDate.sync="searchDTO.case.filedDateStart"
              :endDate.sync="searchDTO.case.filedDateEnd"
              aria-describedby="a0d83c01-f8af-4a3d-8c79-5256302150d2"/>
            <field-description id="a0d83c01-f8af-4a3d-8c79-5256302150d2"
                               message-key="page.searchCriteria.case.field.caseFiledDate.description"/>
          </v-col>
          <v-col cols="12">
            <c-text-field
              :label="$t('page.searchCriteria.case.field.originatingCaseNumber')"
              v-model="searchDTO.case.originatingCourtCaseNumber"
              maxlength="50"
              outlined
              hide-details="auto"
              aria-describedby="817b8757-1ce0-4179-a020-db83b8097432"/>
            <field-description id="817b8757-1ce0-4179-a020-db83b8097432"
                               message-key="page.searchCriteria.case.field.originatingCourtCaseNumber.description"/>
          </v-col>
          <v-col cols="12">
            <c-checkbox
              :label="$t('page.searchCriteria.case.field.excludeClosed')"
              v-model="searchDTO.case.excludeClosed"
              class="mt-0"
              hide-details="auto"
              aria-describedby="a0549454-b002-4539-a236-7a31504991a9"/>
            <field-description id="a0549454-b002-4539-a236-7a31504991a9"
                               message-key="page.searchCriteria.case.field.excludeClosed.description"/>
          </v-col>
        </v-row>

      </form>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import DateRangePicker from '@components/support/DateRangePicker';
import FieldDescription from '@components/support/FieldDescription';
import SearchCriteriaMixin from '@/mixins/searchCriteria';
import { useApplicationStore } from '@/stores/applicationStore';

const applicationStore = useApplicationStore();

export default {
  components: { DateRangePicker, FieldDescription },
  mixins: [ SearchCriteriaMixin ],
  data () {
    return {
      categories: [],
      caseTypes: [],
      caseSubTypes: [],
      // hardcoded list here since we lack a service to retrieve these in 1.42. If one is added later, clean up with service call
      caseStatusTypes: [
        {
          caseStatusTypeID: 1000001,
          caseStatusTypeName: 'Consolidated'
        },
        {
          caseStatusTypeID: 1000002,
          caseStatusTypeName: 'Active'
        },
        {
          caseStatusTypeID: 1000005,
          caseStatusTypeName: 'Closed'
        },
        {
          caseStatusTypeID: 1000006,
          caseStatusTypeName: 'Stale'
        },
        {
          caseStatusTypeID: 1000007,
          caseStatusTypeName: 'Inactive'
        },
        {
          caseStatusTypeID: 1000008,
          caseStatusTypeName: 'In Bankruptcy'
        },
        {
          caseStatusTypeID: 1000009,
          caseStatusTypeName: 'Pending Appeal'
        },
        {
          caseStatusTypeID: 2000010,
          caseStatusTypeName: 'Admin (No Status)'
        },
        {
          caseStatusTypeID: 2000012,
          caseStatusTypeName: 'Migrated/Inactive'
        },
        {
          caseStatusTypeID: 2000014,
          caseStatusTypeName: 'Repository'
        },
        {
          caseStatusTypeID: 2000015,
          caseStatusTypeName: 'Judgment Entered'
        },
        {
          caseStatusTypeID: 2000016,
          caseStatusTypeName: 'Judgment / Lien'
        },
        {
          caseStatusTypeID: 2000017,
          caseStatusTypeName: 'Custody - Complaint/Petition Pending'
        },
        {
          caseStatusTypeID: 2000018,
          caseStatusTypeName: 'Custody - Final Order Entered'
        },
        {
          caseStatusTypeID: 2000019,
          caseStatusTypeName: 'Custody - Closed'
        }
      ]
    };
  },
  computed: {
    caseLocations () {
      return applicationStore.getCaseLocationsByCourt(this.searchDTO.courtID);
    },
    isSingleCaseLocationMode () {
      return applicationStore.isSingleCaseLocationMode;
    }
  },
  watch: {
    'searchDTO.courtID': {
      immediate: true,
      handler (newValue) {
        if (!_.isNil(newValue))
        {
          axios.get(this.$cove.getAPI({ name: 'api.court.case.categories', params: { courtID: newValue } }))
            .then((response) => {
              this.categories = _.defaultTo(response.data, []);
            });
        }
        else
        {
          this.categories = [];
        }
      }
    },
    'searchDTO.case.caseCategoryID': {
      immediate: true,
      handler (newValue) {
        if (!_.isNil(newValue))
        {
          // there is no "approved" place to hook these in in 1.42. these calls should be centralized if possible later
          this.$cove.setAPIs({
            'api.court.case.types': {
              path: '/courts/:courtID/cms/casetypes'
            }
          });
          axios.get(this.$cove.getAPI({
            name: 'api.court.case.types',
            params: { courtID: this.searchDTO.courtID },
            query: { caseCategoryID: newValue }
          }))
            .then((response) => {
              this.caseTypes = _.defaultTo(response.data, []);
            });
        }
        else
        {
          this.caseTypes = [];
        }
      }
    },
    'searchDTO.case.caseTypeID': {
      immediate: true,
      handler (newValue) {
        if (!_.isNil(newValue))
        {
          // there is no "approved" place to hook these in in 1.42. these calls should be centralized if possible later
          this.$cove.setAPIs({
            'api.court.case.subtypes': {
              path: '/courts/:courtID/cms/casesubtypes'
            }
          });
          axios.get(this.$cove.getAPI({
            name: 'api.court.case.subtypes',
            params: { courtID: this.searchDTO.courtID },
            query: { caseTypeID: newValue }
          }))
            .then((response) => {
              this.caseSubTypes = _.defaultTo(response.data, []);
            });
        }
        else
        {
          this.caseSubTypes = [];
        }
      }
    },
    'searchDTO.advanced' (newValue) {
      if (newValue)
      {
        // only change this query type if they didn't enter anything yet
        if (this.searchDTO.case.caseTitle === null)
        {
          this.searchDTO.case.caseTitleQueryTypeID = this.getDefaultQueryType(true);
        }
      }
    }
  },
  methods: {
    changeCourt () {
      this.searchDTO.case.locationID = null;
      this.searchDTO.case.caseCategoryID = null;
      this.changeCategory();
    },
    changeCategory () {
      this.searchDTO.case.caseTypeID = null;
      this.changeType();
    },
    changeType () {
      this.searchDTO.case.caseSubTypeID = null;
    }
  }
};
</script>
